import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";
import { motion } from "framer-motion";

export default function Manifesto() {
  const { content } = useSite();
  const m = content?.manifesto || {};
  const chapters = m.chapters || [];

  return (
    <section id="manifiesto" className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <span className="font-mono-jb text-xs uppercase tracking-[0.35em] text-[color:var(--aurex-accent-soft)]">
                {m.overline || "Manifiesto"}
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-[color:var(--aurex-text)] sm:text-5xl">
                {m.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex flex-col">
            {chapters.map((c, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <motion.div
                  whileHover={{ x: 8 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-8 md:gap-10 md:py-10"
                >
                  <span className="font-mono-jb text-sm text-zinc-600 transition-colors duration-300 group-hover:text-[color:var(--aurex-accent)]">
                    {c.number}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl font-bold text-[color:var(--aurex-text)] md:text-3xl">
                      {c.title}
                    </h3>
                    <p className="mt-3 max-w-xl text-base leading-relaxed text-[color:var(--aurex-muted)]">
                      {c.text}
                    </p>
                  </div>
                </motion.div>
              </Reveal>
            ))}
            <div className="border-t border-white/10" />
          </div>
        </div>
      </div>
    </section>
  );
}
